module.exports = __webpack_public_path__ + "static/img/8@2x.4d2aa337.png";